import * as Core from '@prezly/content-format';
export var DocumentNode;

(function (DocumentNode) {
  DocumentNode.TYPE = Core.DocumentNode.TYPE;

  function isDocumentNode(value) {
    return Core.DocumentNode.isDocumentNode(value);
  }

  DocumentNode.isDocumentNode = isDocumentNode;

  function valueDocumentNode(value) {
    return Core.DocumentNode.validateDocumentNode(value, BlockNode.validateBlockNode);
  }

  DocumentNode.valueDocumentNode = valueDocumentNode;
})(DocumentNode || (DocumentNode = {}));

export var Node;

(function (Node) {
  function isNode(value) {
    return InlineNode.isInlineNode(value) || BlockNode.isBlockNode(value);
  }

  Node.isNode = isNode;

  function valueNode(value) {
    var _InlineNode$validateI;

    return (_InlineNode$validateI = InlineNode.validateInlineNode(value)) !== null && _InlineNode$validateI !== void 0 ? _InlineNode$validateI : BlockNode.validateBlockNode(value);
  }

  Node.valueNode = valueNode;
})(Node || (Node = {}));

export var InlineNode;

(function (InlineNode) {
  function isInlineNode(value) {
    return Text.isText(value) || LinkNode.isLinkNode(value) || VariableNode.isVariableNode(value);
  }

  InlineNode.isInlineNode = isInlineNode;

  function validateInlineNode(value) {
    var _ref, _Text$validateText;

    return (_ref = (_Text$validateText = Text.validateText(value)) !== null && _Text$validateText !== void 0 ? _Text$validateText : LinkNode.validateLinkNode(value)) !== null && _ref !== void 0 ? _ref : VariableNode.validateVariableNode(value);
  }

  InlineNode.validateInlineNode = validateInlineNode;
})(InlineNode || (InlineNode = {}));

export var BlockNode;

(function (BlockNode) {
  function isBlockNode(value) {
    return AttachmentNode.isAttachmentNode(value) || ButtonBlockNode.isButtonBlockNode(value) || CalloutNode.isCalloutNode(value) || ContactNode.isContactNode(value) || CoverageNode.isCoverageNode(value) || DividerNode.isDividerNode(value) || EmbedNode.isEmbedNode(value) || GalleryNode.isGalleryNode(value) || HeadingNode.isHeadingNode(value) || HtmlNode.isHtmlNode(value) || ImageNode.isImageNode(value) || ParagraphNode.isParagraphNode(value) || PlaceholderNode.isPlaceholderNode(value) || QuoteNode.isQuoteNode(value) || ListNode.isListNode(value) || StoryBookmarkNode.isStoryBookmarkNode(value) || VideoNode.isVideoNode(value) || TableNode.isTableNode(value) || TableRowNode.isTableRowNode(value) || TableCellNode.isTableCellNode(value);
  }

  BlockNode.isBlockNode = isBlockNode;

  function validateBlockNode(value) {
    var _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14, _ref15, _ref16, _ref17, _ref18, _ref19, _AttachmentNode$valid;

    return (_ref2 = (_ref3 = (_ref4 = (_ref5 = (_ref6 = (_ref7 = (_ref8 = (_ref9 = (_ref10 = (_ref11 = (_ref12 = (_ref13 = (_ref14 = (_ref15 = (_ref16 = (_ref17 = (_ref18 = (_ref19 = (_AttachmentNode$valid = AttachmentNode.validateAttachmentNode(value)) !== null && _AttachmentNode$valid !== void 0 ? _AttachmentNode$valid : ButtonBlockNode.validateButtonBlockNode(value)) !== null && _ref19 !== void 0 ? _ref19 : CalloutNode.validateCalloutNode(value)) !== null && _ref18 !== void 0 ? _ref18 : ContactNode.validateContactNode(value)) !== null && _ref17 !== void 0 ? _ref17 : CoverageNode.validateCoverageNode(value)) !== null && _ref16 !== void 0 ? _ref16 : DividerNode.validateDividerNode(value)) !== null && _ref15 !== void 0 ? _ref15 : EmbedNode.validateEmbedNode(value)) !== null && _ref14 !== void 0 ? _ref14 : GalleryNode.validateGalleryNode(value)) !== null && _ref13 !== void 0 ? _ref13 : HeadingNode.validateHeadingNode(value)) !== null && _ref12 !== void 0 ? _ref12 : HtmlNode.validateHtmlNode(value)) !== null && _ref11 !== void 0 ? _ref11 : ImageNode.validateImageNode(value)) !== null && _ref10 !== void 0 ? _ref10 : ParagraphNode.validateParagraphNode(value)) !== null && _ref9 !== void 0 ? _ref9 : PlaceholderNode.validatePlaceholderNode(value)) !== null && _ref8 !== void 0 ? _ref8 : QuoteNode.validateQuoteNode(value)) !== null && _ref7 !== void 0 ? _ref7 : ListNode.validateListNode(value)) !== null && _ref6 !== void 0 ? _ref6 : StoryBookmarkNode.validateStoryBookmarkNode(value)) !== null && _ref5 !== void 0 ? _ref5 : VideoNode.validateVideoNode(value)) !== null && _ref4 !== void 0 ? _ref4 : TableNode.validateTableNode(value)) !== null && _ref3 !== void 0 ? _ref3 : TableRowNode.validateTableRowNode(value)) !== null && _ref2 !== void 0 ? _ref2 : TableCellNode.validateTableCellNode(value);
  }

  BlockNode.validateBlockNode = validateBlockNode;
})(BlockNode || (BlockNode = {}));

export var ComposedElement;

(function (ComposedElement) {
  function isComposedElement(value) {
    return DocumentNode.isDocumentNode(value) || LinkNode.isLinkNode(value) || HeadingNode.isHeadingNode(value) || ImageNode.isImageNode(value) || ParagraphNode.isParagraphNode(value) || CalloutNode.isCalloutNode(value) || QuoteNode.isQuoteNode(value) || ListNode.isListNode(value) || ListItemNode.isListItemNode(value) || ListItemTextNode.isListItemTextNode(value) || TableNode.isTableNode(value) || TableRowNode.isTableRowNode(value) || TableCellNode.isTableCellNode(value);
  }

  ComposedElement.isComposedElement = isComposedElement;

  function validateComposedElement(value) {
    var _ref20, _ref21, _ref22, _ref23, _ref24, _ref25, _ref26, _ref27, _ref28, _ref29, _DocumentNode$valueDo;

    return (_ref20 = (_ref21 = (_ref22 = (_ref23 = (_ref24 = (_ref25 = (_ref26 = (_ref27 = (_ref28 = (_ref29 = (_DocumentNode$valueDo = DocumentNode.valueDocumentNode(value)) !== null && _DocumentNode$valueDo !== void 0 ? _DocumentNode$valueDo : LinkNode.validateLinkNode(value)) !== null && _ref29 !== void 0 ? _ref29 : HeadingNode.validateHeadingNode(value)) !== null && _ref28 !== void 0 ? _ref28 : ParagraphNode.validateParagraphNode(value)) !== null && _ref27 !== void 0 ? _ref27 : CalloutNode.validateCalloutNode(value)) !== null && _ref26 !== void 0 ? _ref26 : QuoteNode.validateQuoteNode(value)) !== null && _ref25 !== void 0 ? _ref25 : ListNode.validateListNode(value)) !== null && _ref24 !== void 0 ? _ref24 : ListItemNode.validateListItemNode(value)) !== null && _ref23 !== void 0 ? _ref23 : ListItemTextNode.validateListItemTextNode(value)) !== null && _ref22 !== void 0 ? _ref22 : TableNode.validateTableNode(value)) !== null && _ref21 !== void 0 ? _ref21 : TableRowNode.validateTableRowNode(value)) !== null && _ref20 !== void 0 ? _ref20 : TableCellNode.validateTableCellNode(value);
  }

  ComposedElement.validateComposedElement = validateComposedElement;
})(ComposedElement || (ComposedElement = {})); // NODES


export var BlockAlignment = Core.AlignableBlock.Alignment;
export var TextAlignment = Core.AlignableText.Alignment;
export var OEmbedInfo = Core.OEmbedInfo;
export var Text;

(function (Text) {
  Text.Style = Core.Stylable.Style;

  function isText(value) {
    return Core.Text.isText(value);
  }

  Text.isText = isText;

  function validateText(value) {
    return Core.Text.validateText(value);
  }

  Text.validateText = validateText;
})(Text || (Text = {}));

export var LinkNode;

(function (LinkNode) {
  LinkNode.TYPE = Core.LinkNode.TYPE;

  function isLinkNode(value) {
    return Core.LinkNode.isLinkNode(value);
  }

  LinkNode.isLinkNode = isLinkNode;

  function validateLinkNode(value) {
    return Core.LinkNode.validateLinkNode(value, Text.validateText);
  }

  LinkNode.validateLinkNode = validateLinkNode;
})(LinkNode || (LinkNode = {}));

export var VariableNode;

(function (VariableNode) {
  VariableNode.TYPE = Core.VariableNode.TYPE;
  var Key;

  (function (Key) {
    Key["PUBLICATION_DATE"] = "publication.date";
  })(Key = VariableNode.Key || (VariableNode.Key = {}));

  function isVariableNode(value) {
    return Core.VariableNode.isVariableNode(value);
  }

  VariableNode.isVariableNode = isVariableNode;

  function validateVariableNode(value) {
    return Core.VariableNode.validateVariableNode(value, function (key) {
      return Object.values(Key).includes(key);
    });
  }

  VariableNode.validateVariableNode = validateVariableNode;
})(VariableNode || (VariableNode = {}));

export var AttachmentNode;

(function (AttachmentNode) {
  AttachmentNode.TYPE = Core.AttachmentNode.TYPE;

  function isAttachmentNode(value) {
    return Core.AttachmentNode.isAttachmentNode(value);
  }

  AttachmentNode.isAttachmentNode = isAttachmentNode;

  function validateAttachmentNode(value) {
    return Core.AttachmentNode.validateAttachmentNode(value);
  }

  AttachmentNode.validateAttachmentNode = validateAttachmentNode;
})(AttachmentNode || (AttachmentNode = {}));

export var BookmarkNode = Core.BookmarkNode;
export var ButtonBlockNode = Core.ButtonBlockNode;
export var CalloutNode;

(function (CalloutNode) {
  CalloutNode.TYPE = Core.CalloutNode.TYPE;
  CalloutNode.Alignment = Core.AlignableText.Alignment;

  function isCalloutNode(value) {
    return Core.CalloutNode.isCalloutNode(value);
  }

  CalloutNode.isCalloutNode = isCalloutNode;

  function validateCalloutNode(value) {
    return Core.AlignableText.validateAlignableText(Core.CalloutNode.validateCalloutNode(value, InlineNode.validateInlineNode), false);
  }

  CalloutNode.validateCalloutNode = validateCalloutNode;
})(CalloutNode || (CalloutNode = {}));

export var ContactNode = Core.ContactNode;
export var CoverageNode = Core.CoverageNode;
export var DividerNode = Core.DividerNode;
export var EmbedNode = Core.EmbedNode;
export var GalleryNode = Core.GalleryNode;
export var HeadingNode;

(function (HeadingNode) {
  HeadingNode.Type = Core.HeadingNode.Type;
  HeadingNode.Alignment = Core.AlignableText.Alignment;
  HeadingNode.Role = Core.HeadingNode.Role;

  function isHeadingNode(value, type) {
    return type ? Core.HeadingNode.isHeadingNode(value, type) : Core.HeadingNode.isHeadingNode(value);
  }

  HeadingNode.isHeadingNode = isHeadingNode;

  function isTitleHeadingNode(value) {
    return Core.HeadingNode.isTitleHeadingNode(value);
  }

  HeadingNode.isTitleHeadingNode = isTitleHeadingNode;

  function isSubtitleHeadingNode(value) {
    return Core.HeadingNode.isSubtitleHeadingNode(value);
  }

  HeadingNode.isSubtitleHeadingNode = isSubtitleHeadingNode;

  function validateHeadingNode(value) {
    return Core.AlignableText.validateAlignableText(Core.HeadingNode.validateHeadingNode(value, InlineNode.validateInlineNode), false);
  }

  HeadingNode.validateHeadingNode = validateHeadingNode;
})(HeadingNode || (HeadingNode = {}));

export var HtmlNode = Core.HtmlNode;
export var ImageNode;

(function (ImageNode) {
  ImageNode.TYPE = Core.ImageNode.TYPE;
  ImageNode.Layout = Core.ImageNode.Layout;
  ImageNode.Alignment = Core.AlignableBlock.Alignment;

  function isImageNode(value) {
    return Core.ImageNode.isImageNode(value);
  }

  ImageNode.isImageNode = isImageNode;

  function validateImageNode(value) {
    return Core.AlignableBlock.validateAlignableBlock(Core.ComposedElement.validateComposedElement(Core.ImageNode.validateImageNode(value), ImageNode.TYPE, InlineNode.validateInlineNode));
  }

  ImageNode.validateImageNode = validateImageNode;
})(ImageNode || (ImageNode = {}));

export var ParagraphNode;

(function (ParagraphNode) {
  ParagraphNode.TYPE = Core.ParagraphNode.TYPE;
  ParagraphNode.Alignment = Core.AlignableText.Alignment;

  function isParagraphNode(value) {
    return Core.ParagraphNode.isParagraphNode(value);
  }

  ParagraphNode.isParagraphNode = isParagraphNode;

  function validateParagraphNode(value) {
    return Core.AlignableText.validateAlignableText(Core.ParagraphNode.validateParagraphNode(value, InlineNode.validateInlineNode), false);
  }

  ParagraphNode.validateParagraphNode = validateParagraphNode;
})(ParagraphNode || (ParagraphNode = {}));

export var PlaceholderNode = Core.PlaceholderNode;
export var QuoteNode;

(function (QuoteNode) {
  QuoteNode.TYPE = Core.QuoteNode.TYPE;
  QuoteNode.Alignment = Core.AlignableText.Alignment;

  function isQuoteNode(value) {
    return Core.QuoteNode.isQuoteNode(value);
  }

  QuoteNode.isQuoteNode = isQuoteNode;

  function validateQuoteNode(value) {
    return Core.AlignableText.validateAlignableText(Core.QuoteNode.validateQuoteNode(value, InlineNode.validateInlineNode), false);
  }

  QuoteNode.validateQuoteNode = validateQuoteNode;
})(QuoteNode || (QuoteNode = {}));

export var StoryBookmarkNode = Core.StoryBookmarkNode;
export var VideoNode = Core.VideoNode;
export var ListNode;

(function (ListNode) {
  ListNode.Type = Core.ListNode.Type;
  ListNode.Alignment = Core.AlignableText.Alignment;

  function isListNode(value) {
    return Core.ListNode.isListNode(value);
  }

  ListNode.isListNode = isListNode;

  function validateListNode(value, type) {
    return Core.AlignableText.validateAlignableText(type ? validateRecursiveListNode(value, type) : validateRecursiveListNode(value), false);
  }

  ListNode.validateListNode = validateListNode;
})(ListNode || (ListNode = {}));

export var ListItemNode;

(function (ListItemNode) {
  ListItemNode.TYPE = Core.ListItemNode.TYPE;

  function isListItemNode(value) {
    return Core.ListItemNode.isListItemNode(value);
  }

  ListItemNode.isListItemNode = isListItemNode;

  function validateListItemNode(value) {
    return Core.ListItemNode.validateListItemNode(value, function (value) {
      var _ListItemTextNode$val;

      return (_ListItemTextNode$val = ListItemTextNode.validateListItemTextNode(value)) !== null && _ListItemTextNode$val !== void 0 ? _ListItemTextNode$val : validateRecursiveListNode(value);
    });
  }

  ListItemNode.validateListItemNode = validateListItemNode;
})(ListItemNode || (ListItemNode = {}));

export var ListItemTextNode;

(function (ListItemTextNode) {
  ListItemTextNode.TYPE = Core.ListItemTextNode.TYPE;

  function isListItemTextNode(value) {
    return Core.ListItemTextNode.isListItemTextNode(value);
  }

  ListItemTextNode.isListItemTextNode = isListItemTextNode;

  function validateListItemTextNode(value) {
    return Core.ListItemTextNode.validateListItemTextNode(value, InlineNode.validateInlineNode);
  }

  ListItemTextNode.validateListItemTextNode = validateListItemTextNode;
})(ListItemTextNode || (ListItemTextNode = {}));

function validateRecursiveListNode(value, type) {
  function validateBlock(value) {
    var _ListItemTextNode$val2;

    return (_ListItemTextNode$val2 = ListItemTextNode.validateListItemTextNode(value)) !== null && _ListItemTextNode$val2 !== void 0 ? _ListItemTextNode$val2 : validateRecursiveListNode(value);
  }

  return type ? Core.ListNode.validateListNode(value, type, validateBlock) : Core.ListNode.validateListNode(value, validateBlock);
}

export var TableNode;

(function (TableNode) {
  TableNode.TYPE = Core.TableNode.TYPE;
  TableNode.TableHeader = Core.TableNode.TableHeader;

  function isTableNode(value) {
    return Core.TableNode.isTableNode(value);
  }

  TableNode.isTableNode = isTableNode;

  function validateTableNode(value) {
    return Core.TableNode.validateTableNode(value, n => TableRowNode.validateTableRowNode(n));
  }

  TableNode.validateTableNode = validateTableNode;
})(TableNode || (TableNode = {}));

export var TableRowNode;

(function (TableRowNode) {
  TableRowNode.TYPE = Core.TableRowNode.TYPE;

  function isTableRowNode(value) {
    return Core.TableRowNode.isTableRowNode(value);
  }

  TableRowNode.isTableRowNode = isTableRowNode;

  function validateTableRowNode(value) {
    return Core.TableRowNode.validateTableRowNode(value, n => TableCellNode.validateTableCellNode(n));
  }

  TableRowNode.validateTableRowNode = validateTableRowNode;
})(TableRowNode || (TableRowNode = {}));

export var TableCellNode;

(function (TableCellNode) {
  TableCellNode.TYPE = Core.TableCellNode.TYPE;

  function isTableCellNode(value) {
    return Core.TableCellNode.isTableCellNode(value);
  }

  TableCellNode.isTableCellNode = isTableCellNode;

  function validateTableCellNode(value) {
    return Core.TableCellNode.validateTableCellNode(value, n => ParagraphNode.validateParagraphNode(n) || ListNode.validateListNode(n));
  }

  TableCellNode.validateTableCellNode = validateTableCellNode;
})(TableCellNode || (TableCellNode = {}));